import { gql } from '@apollo/client/core'
import { Domiciliation } from 'globals/models/Domiciliation'

export const DOMICILIATION = gql`
  query domiciliation($domiciliationId: ID!) {
    domiciliation(domiciliationId: $domiciliationId) {
      id
      firstname
      lastname
      email
      status
      canceledAt
      clientSince
      countryCode
      address {
        id
        shortname
        fullAddress
        externallyManaged
        ownAddress
      }
      forwardingAddress {
        id
        name
        streetAddress
        postalCode
        city
        country
      }
      nextForwardingDate
      mailForwardingFrequency
      pendingUserMailsCount
      phoneNumber
      postalProcurationReady
      printablePostalProcuration
      society {
        id
        name
        legalStatus
        brandName
      }
      userMailOption
      leaderAddress {
        id
        name
        streetAddress
        postalCode
        city
        country
      }
      leaderEmail
      leaderPhoneNumber
      legalDocuments {
        id
        category
        fileRecto
        fileVerso
      }
      contactOfSharings {
        id
        firstname
        lastname
        email
      }
      userMailsCount
      subscriptionState
      npai
      firstPaymentCountryOrigin
      cancelationReason
    }
  }
`

export interface DomiciliationVariables {
  domiciliationId: number
}

export interface DomiciliationResult {
  domiciliation: Domiciliation
}
